import React, { useEffect, useState } from 'react';
import {
  Box,
  Card,
  CardContent,
  Typography,
  TextField,
  Button,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Switch,
  FormControlLabel,
  Alert,
  Chip,
} from '@mui/material';
import { gamesAPI } from '../../Api';
import PageHeader from '../../components/PageHeader';

export default function GamesList() {
  const [games, setGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);
  const [form, setForm] = useState({
    name: '',
    slug: '',
    balance: '',
    winPercent: '',
    winMultiplier: '2',
    isActive: true,
  });

  const loadGames = async () => {
    setLoading(true);
    try {
      const res = await gamesAPI.list();
      setGames(res.data?.data || []);
    } catch (e) {
      setMessage({ type: 'error', text: e.response?.data?.message || 'Ошибка загрузки игр' });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadGames();
  }, []);

  const onChange = (field) => (e) => {
    const value = field === 'isActive' ? e.target.checked : e.target.value;
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const submit = async (e) => {
    e.preventDefault();
    setMessage(null);

    try {
      const payload = {
        name: String(form.name || '').trim(),
        slug: String(form.slug || '').trim(),
        balance: Number(form.balance || 0),
        winPercent: Number(form.winPercent || 0),
        winMultiplier: Number(form.winMultiplier || 2),
        isActive: Boolean(form.isActive),
      };

      await gamesAPI.create(payload);
      setMessage({ type: 'success', text: 'Игра успешно добавлена' });
      setForm({
        name: '',
        slug: '',
        balance: '',
        winPercent: '',
        winMultiplier: '2',
        isActive: true,
      });
      await loadGames();
    } catch (e2) {
      setMessage({ type: 'error', text: e2.response?.data?.message || 'Ошибка создания игры' });
    }
  };

  return (
    <Box>
      <PageHeader title="Игры" />

      {message && (
        <Alert sx={{ mb: 2 }} severity={message.type} onClose={() => setMessage(null)}>
          {message.text}
        </Alert>
      )}

      <Card sx={{ mb: 3 }}>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Добавить игру
          </Typography>
          <Box component="form" onSubmit={submit}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={4}>
                <TextField fullWidth label="Название" value={form.name} onChange={onChange('name')} required />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField fullWidth label="Slug" value={form.slug} onChange={onChange('slug')} required />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField fullWidth label="Баланс игры" type="number" value={form.balance} onChange={onChange('balance')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField fullWidth label="Шанс выигрыша (%)" type="number" value={form.winPercent} onChange={onChange('winPercent')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <TextField fullWidth label="Множитель выигрыша" type="number" value={form.winMultiplier} onChange={onChange('winMultiplier')} />
              </Grid>
              <Grid item xs={12} md={4}>
                <FormControlLabel control={<Switch checked={form.isActive} onChange={onChange('isActive')} />} label="Игра активна" />
              </Grid>
              <Grid item xs={12}>
                <Button type="submit" variant="contained" disabled={loading}>
                  Добавить
                </Button>
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="h6" sx={{ mb: 2 }}>
            Список игр
          </Typography>
          <TableContainer component={Paper} variant="outlined">
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>Название</TableCell>
                  <TableCell>Slug</TableCell>
                  <TableCell>Баланс</TableCell>
                  <TableCell>Шанс (%)</TableCell>
                  <TableCell>Множитель</TableCell>
                  <TableCell>Статус</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {games.map((g) => (
                  <TableRow key={g._id}>
                    <TableCell>{g.name}</TableCell>
                    <TableCell>{g.slug}</TableCell>
                    <TableCell>{Number(g.balance || 0).toLocaleString('ru-RU')}</TableCell>
                    <TableCell>{Number(g.winPercent || 0)}</TableCell>
                    <TableCell>x{Number(g.winMultiplier || 1)}</TableCell>
                    <TableCell>
                      <Chip
                        label={g.isActive ? 'Активна' : 'Выключена'}
                        size="small"
                        color={g.isActive ? 'success' : 'default'}
                        variant={g.isActive ? 'filled' : 'outlined'}
                      />
                    </TableCell>
                  </TableRow>
                ))}
                {!games.length && (
                  <TableRow>
                    <TableCell colSpan={6} align="center">Нет игр</TableCell>
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
        </CardContent>
      </Card>
    </Box>
  );
}
